import axios from "axios";
import { API_MODULE } from "@env";

export const getReportStatistic = (id) =>
  axios.get(`${API_MODULE}/data-statistic/${encodeURIComponent(id)}`);